<kaz-default-frame>
  <div class="relative flex flex-col w-full items-center mt-5 md:mt-0">
    <!-- ProfileInfo -->
    <div class="flex flex-col w-full items-center md:flex-row md:gap-4">
      <!-- Back -->
      @if (!isActive(NavigationBarItem.ENTRIES)) {
        <div
          class="hidden absolute top-[-6px] left-[-90px] p-1.5 pr-3 rounded-full gap-0.5 text-xs text-kaz-black justify-center cursor-pointer hover:bg-kaz-blue/10 md:flex md:flex-row"
          [routerLink]="['/profile/menu',NavigationBarItem.ENTRIES]">
          <fa-icon icon="chevron-left" size="sm"></fa-icon>
          <span>Zurück</span>
        </div>
      }
      <div class="flex justify-center items-center h-16 w-16 rounded-full text-white bg-[#F0811A] select-none">
        <span class="font-normal text-xl tracking-wider">{{ getInitials() }}</span>
      </div>
      <div class="flex flex-col items-center md:items-start">
        <span class="mt-1 text-base text-[#222] font-medium">{{ profile?.firstname }} {{ profile?.lastname }}</span>
        <span class="text-xs text-[#A7A7A7] font-normal leading-4">{{ profile?.mail }}</span>
        <span
        class="text-xs text-[#5088D6] font-medium leading-4 mt-1.5 select-none">Aktiv seit {{ $safeNavigationMigration(profile?.created) | date }}</span>
      </div>
      <div
        class="hidden md:flex md:flex-row md:grow md:gap-8 md:text-base md:text-kaz-blue md:font-medium md:justify-end select-none">
        <div
          class="flex flex-row gap-2 w-[185px] py-1.5 border border-kaz-blue justify-center rounded-full cursor-pointer hover:bg-kaz-blue/10"
          [routerLink]="['/profile/menu',NavigationBarItem.ARCHIVE]"
          [class]="!isActive(NavigationBarItem.ARCHIVE) ? 'bg-white text-kaz-blue' : 'bg-kaz-blue text-white pointer-events-none'">
          <fa-icon icon="box-archive" size="sm"></fa-icon>
          <span>Archiv</span>
        </div>
        <div
          class="flex flex-row gap-2 w-[185px] py-1.5 border border-kaz-blue justify-center rounded-full cursor-pointer hover:bg-kaz-blue/10"
          [routerLink]="['/profile/menu',NavigationBarItem.MESSAGES]"
          [class]="!isActive(NavigationBarItem.MESSAGES) ? 'bg-white text-kaz-blue' : 'bg-kaz-blue text-white pointer-events-none'">
          <fa-icon icon="envelope" size="sm"></fa-icon>
          <span>Nachrichten</span>
        </div>
        <span title="Einstellungen"
          class="flex self-center justify-center p-1.5 rounded-full cursor-pointer hover:bg-kaz-blue/10"
          [class]="isActive(NavigationBarItem.SETTINGS) ? 'pointer-events-none':''"
          [routerLink]="['/profile/menu',NavigationBarItem.SETTINGS]">
          @if (!isActive(NavigationBarItem.SETTINGS)) {
            <fa-icon icon="gear" size="xl"></fa-icon>
          }
          @if (isActive(NavigationBarItem.SETTINGS)) {
            <fa-icon [icon]="['fas','gear']" size="xl"></fa-icon>
          }
        </span>
        <div
          class="hidden flex-row gap-2 w-[185px] py-1.5 border border-kaz-blue justify-center rounded-full cursor-pointer"
          [routerLink]="['/profile/menu',NavigationBarItem.FAVORITES]"
          [class]="!isActive(NavigationBarItem.FAVORITES) ? 'bg-white text-kaz-blue' : 'bg-kaz-blue text-white pointer-events-none'">
          <fa-icon icon="heart" size="sm"></fa-icon>
          <span>Favoriten</span>
        </div>
      </div>
    </div>
    <div class="hidden md:flex md:h-2 md:w-full md:bg-[#FAFAFA] md:mt-10 md:mb-7"></div>

    <!--  Navigation Bar  -->
    <ul class="flex flex-row w-full border-b border-[#D2D2D2] text-base font-medium h-12 mt-1.5 md:hidden">
      @for (tab of navBar; track tab) {
        <li [routerLink]="['/profile/menu',tab.value]"
          class="flex grow h-12 justify-center items-center transition-colors duration-300"
          [style.border-bottom]="tab.current?'1px solid #222222':'0px'"
          [style.color]="tab.current ? '#222222' : '#D2D2D2' ">
          @if (tab.value !== NavigationBarItem.SETTINGS) {
            <span>{{ tab.name }}</span>
          }
          @if (tab.value === NavigationBarItem.SETTINGS) {
            <span>
              @if (!isActive(NavigationBarItem.SETTINGS)) {
                <fa-icon icon="gear"></fa-icon>
              }
              @if (isActive(NavigationBarItem.SETTINGS)) {
                <fa-icon [icon]="['fas','gear']"></fa-icon>
              }
            </span>
          }
        </li>
      }
    </ul>
    @if (isActive(NavigationBarItem.ENTRIES)) {
      <kaz-ads class="w-full" />
    }
    @if (isActive(NavigationBarItem.MESSAGES)) {
      <kaz-messages class="w-full" />
    }
    @if (isActive(NavigationBarItem.ARCHIVE)) {
      <kaz-archive class="w-full" />
    }
    @if (isActive(NavigationBarItem.SETTINGS)) {
      <kaz-settings class="w-full" [profile]="profile" />
    }
    <!--    <kaz-favorites class="w-full" [hidden]="isActive('FAVORITES')"></kaz-favorites>-->
  </div>
</kaz-default-frame>
